import { render, staticRenderFns } from "./MonthCalendarPage.vue?vue&type=template&id=20903524"
import script from "./MonthCalendarPage.vue?vue&type=script&lang=ts"
export * from "./MonthCalendarPage.vue?vue&type=script&lang=ts"
import style0 from "./MonthCalendarPage.vue?vue&type=style&index=0&id=20903524&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports